import { useTagStore } from '~/stores/tag'

import type Tag from '~/entities/tag'
import type TagParent from '~/entities/tagParent'
import type { SeoListsAsyncData } from '~/types/influencerListTagSeo'
import type { MaybeRefOrGetter } from 'vue'

export function useSeoListUrlDataToEntity(
  input: MaybeRefOrGetter<SeoListsAsyncData['urlData']>,
) {
  const { $pinia } = useNuxtApp()
  const urlData = toValue(input)
  const { GET_TAG_FROM_ID, GET_PARENT_FROM_ID } = useTagStore($pinia)

  // We can guaranty non undefined values here since the page would 404 if tags where missing
  const entities = computed<(Tag | TagParent)[]>(() =>
    urlData.map((data) => {
      const fetchFn = data.isParent ? GET_PARENT_FROM_ID : GET_TAG_FROM_ID

      return fetchFn(data.tagId) as Tag | TagParent
    }),
  )

  return { entities } as const
}
